import { gql } from '@apollo/client';

/**
 * 揽收站点 2.0 · 司机上门现场回传（现场联系人 + 建联状态流转）。
 *
 * 灰度 hub 专用的【追加】调用：1.0 的 updatePickupAppointment / handlePickupFailed 仍负责揽收结果
 * （件数/失败原因/揽收时间）与订单事件；本 mutation 只补现场联系人 + 现场照片，并推动站点 link_status
 * （待上门→揽收成功/失败待建联）。二者写的是不同数据，非重复写。
 */
export const SUBMIT_PICKUP_ONSITE_FEEDBACK = gql`
  mutation SubmitPickupOnsiteFeedback($input: OnsiteFeedbackInput!) {
    submitPickupOnsiteFeedback(input: $input)
  }
`;

export interface OnsiteFeedbackInput {
  // 后端为 Long；沿用 1.0 通路做法传字符串原值（雪花号 >2^53，避免 Number() 丢精度），Long 标量可从数字字符串解析
  pickupAppointmentId: string;
  pickupSuccess: boolean;
  onsiteContactName?: string;
  onsiteContactPhone?: string;
  photosS3KeysJson?: string;
  /** 上门备注（司机现场填写，可空） */
  note?: string;
}

export interface SubmitPickupOnsiteFeedbackVariables {
  input: OnsiteFeedbackInput;
}

export interface SubmitPickupOnsiteFeedbackResponse {
  submitPickupOnsiteFeedback: boolean;
}
